import { render, staticRenderFns } from "./AddPersonToggle.vue?vue&type=template&id=99c97094&scoped=true&"
import script from "./AddPersonToggle.vue?vue&type=script&lang=js&"
export * from "./AddPersonToggle.vue?vue&type=script&lang=js&"
import style0 from "./AddPersonToggle.vue?vue&type=style&index=0&id=99c97094&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c97094",
  null
  
)

export default component.exports